import React, { ReactElement } from 'react';

interface StartTradingNowLinkProps {
	icon: ReactElement;
	class: string;
	title: string;
	link: string;
	withArrow: boolean;
	isHovered?: boolean;
	soonText?: string;
	setIsHovered: (value: boolean) => void;
}

const StartTradingNowLinkComponent = (props: StartTradingNowLinkProps) => {
	return (
		<button
			className={`startTradingNowLink ${props.class}`}
			onClick={() => window.open(props.link)}
			onMouseEnter={() => props.setIsHovered(true)}
			onMouseLeave={() => props.setIsHovered(false)}
		>
			{props.icon}
			{
				props.soonText ? (
					<div className="startTradingNowLink_text">
						<span className="startTradingNowLink_text_current">{props.title}</span>
						<span className="startTradingNowLink_text_soon">{props.soonText}</span>
					</div>
				) : (
					<span>{props.title}</span>
				)
			}
			{
				props.withArrow ? (
					<svg className="startTradingNowLink_svg" xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none">
						<path d="M1 9L9 1" stroke="white" strokeWidth="1.5" strokeLinecap="round"/>
						<path d="M8.25 9C8.25 9.41421 8.58579 9.75 9 9.75C9.41421 9.75 9.75 9.41421 9.75 9H8.25ZM8.25 1V9H9.75V1H8.25Z" fill="white"/>
						<path d="M9 1H1" stroke="white" strokeWidth="1.5" strokeLinecap="round"/>
					</svg>
				) : null
			}
		</button>
	);
};

export default StartTradingNowLinkComponent;